import validator from './validator.js'

export default {
  request: {
    error: 'エラーが発生しました：',
    permissionError: {
      title: 'ティーシ',
    },
    codeMessage: {
      message1: 'ログインしていないか、トークンが無効です。',
      message2: '申し訳ありませんが、権限が不足しています。',
      message3:
        '未知のエラーが発生しました。しばらくしてから再試行してください。',
    },
    loginBox: {
      title: 'ログアウトしますか？',
      confirmButtonText: '再ログイン',
    },
    networkError:
      'ネットワークの異常が発生しました。しばらくしてから再試行してください！',
  },
  publish: {
    text: '投稿',
    fail: '投稿に失敗しました。',
    success: '投稿に成功しました。',
  },
  push: {
    text: 'プッシュ',
    fail: 'プッシュに失敗しました。',
    success: 'プッシュに成功しました。',
  },
  download: {
    text: 'ダウンロード',
    fail: 'ダウンロードに失敗しました。',
    success: 'ダウンロードに成功しました。',
  },
  submitButtonText: '送信',
  confirmButtonText: '確定',
  cancelButtonText: 'キャンセル',
  deleteTips: '本当に削除しますか？',
  form: {
    search: '検索',
  },
  creativeType: {
    image: '画像',
    video: 'ビデオ',
    endcard: '動的エンドカード',
    interactiveVideo: 'インタラクティブなビデオ',
    panorama: 'パノラマエンドカード',
  },
  validator,
}
